import { jsx as _jsx } from "react/jsx-runtime";
import { useIoContext, useStoreActions } from '~/contexts';
export function TutorialVideosPlayedVideo(param) {
    let { video, onWatch } = param;
    const { YoutubePlayer } = useIoContext();
    const { logBI } = useStoreActions();
    return /*#__PURE__*/ _jsx(YoutubePlayer, {
        width: "none",
        height: "none",
        controls: true,
        url: "https://youtu.be/".concat(video.id),
        testId: "tutorial-played-video",
        onStart: ()=>{
            if (!video.watched) {
                onWatch(video);
            }
            logBI(11215, {
                videoId: video.id,
                title: video.title
            });
        }
    });
}
